var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon",style:(_vm.svgStyle),attrs:{"viewBox":_vm.viewBox,"preserveAspectRatio":"xMidYMid meet","aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }